
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "69674786a3e551d39902bbb5";
              window.beaePageSetting.pageTitle = "页脚"; 
              window.beaePageSetting.pageType = "footer";

          let js_JMN5KDII = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-1iacv74lsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1iacv74l',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1iacv74l');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1iacv74l: ', ex)
      };
    

      try {
        let argid = 'beae-4sj8rusmlinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4sj8rusm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4sj8rusm');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4sj8rusm: ', ex)
      };
    

      try {
        let argid = 'beae-6jsxoocllinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6jsxoocl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6jsxoocl');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6jsxoocl: ', ex)
      };
    

      try {
        let argid = 'beae-gyo78a5ylinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gyo78a5y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gyo78a5y');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gyo78a5y: ', ex)
      };
    

      try {
        let argid = 'beae-v3yf1ngmblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-v3yf1ngm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-v3yf1ngm');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-v3yf1ngm: ', ex)
      };
    

      try {
        let argid = 'beae-748x873jblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-748x873j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-748x873j');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-748x873j: ', ex)
      };
    

      try {
        let argid = 'beae-h8zua7tvblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h8zua7tv',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h8zua7tv');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h8zua7tv: ', ex)
      };
    

      try {
        let argid = 'beae-5lxyiv2vsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5lxyiv2v',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5lxyiv2v');
        args.el = args.els[0];
        ((g) => { window.BeaeSlider&&!g.noRunJs&&window.BeaeSlider(g) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5lxyiv2v: ', ex)
      };
    

      try {
        let argid = 'beae-cg95ydmllc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cg95ydml',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cg95ydml');
        args.el = args.els[0];
        ((h) => { let g=h.checkLive;function u(_){return{input:_.querySelector('input[name="locale_code"], input[name="country_code"]'),button:_.querySelector("button.beae-current-value"),panel:_.querySelector(".beae-language-results"),search:_.querySelector('input[name="language_filter"]'),resetButton:_.querySelector(".beae-reset-button")}}function f(_,M){const V=h.el.querySelector("form.beae-localization");M.input.value=_.currentTarget.dataset.value,V&&V.submit()}function b(_){_.button.focus(),_.panel.classList.toggle("hidden-dropdown"),_.button.setAttribute("aria-expanded",(_.button.getAttribute("aria-expanded")==="false").toString());const M=_.button.getBoundingClientRect();window.innerHeight-M.bottom<_.panel.offsetHeight?(_.panel.style.top="auto",_.panel.style.bottom="100%"):(_.panel.style.top="100%",_.panel.style.bottom="auto")}function k(_){return _.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function m(_,M){const V=k(M.search.value),L=_.querySelectorAll(".beae-languages li");L.length,M.resetButton.classList.toggle("hidden",!V),L.forEach(T=>{k(T.querySelector(".beae-language-name").textContent).indexOf(V)>-1?T.classList.remove("beae-hidden"):T.classList.add("beae-hidden")})}function y(_){_.code.toUpperCase()==="ENTER"&&_.preventDefault()}function S(_,M,V){_.stopPropagation(),V.search.value="",m(M,V)}function B(_,M,V){(!M.contains(_.target)||!M.contains(_.relatedTarget))&&(w(M,V),V.button.setAttribute("aria-expanded",(V.button.getAttribute("aria-expanded")==="false").toString()))}function w(_,M){M.panel.classList.add("hidden-dropdown"),M.search&&(M.search.value="",m(_,M))}function $(_){const M=u(_);g&&_.addEventListener("focusout",V=>B(V,_,M)),M.button.addEventListener("click",()=>b(M)),_.querySelectorAll(".beae-language-name").forEach(V=>V.addEventListener("click",L=>f(L,M))),M.search&&(M.search.addEventListener("keyup",()=>m(_,M)),M.search.addEventListener("keydown",y)),M.resetButton&&(M.resetButton.addEventListener("click",V=>S(V,_,M)),M.resetButton.addEventListener("mousedown",V=>V.preventDefault()))}h.el.querySelectorAll(".beae-localization").forEach($) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cg95ydml: ', ex)
      };
    

      try {
        let argid = 'beae-tt8ugopvlc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tt8ugopv',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tt8ugopv');
        args.el = args.els[0];
        ((x) => { let h=x.checkLive;function g(C){return{input:C.querySelector('input[name="locale_code"], input[name="country_code"]'),button:C.querySelector("button.beae-current-value"),panel:C.querySelector(".beae-country-results"),search:C.querySelector('input[name="country_filter"]'),resetButton:C.querySelector(".beae-reset-button")}}function u(C,_){const M=x.el.querySelector("form.beae-localization");_.input.value=C.currentTarget.dataset.value,M&&M.submit()}function f(C){C.button.focus(),C.panel.classList.toggle("hidden-dropdown"),C.button.setAttribute("aria-expanded",(C.button.getAttribute("aria-expanded")==="false").toString());const _=C.button.getBoundingClientRect();window.innerHeight-_.bottom<C.panel.offsetHeight?(C.panel.style.top="auto",C.panel.style.bottom="100%"):(C.panel.style.top="100%",C.panel.style.bottom="auto")}function b(C){return C.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function k(C,_){const M=b(_.search.value),V=C.querySelectorAll(".beae-countries li");V.length,_.resetButton.classList.toggle("hidden",!M),V.forEach(L=>{b(L.querySelector(".beae-country-name").textContent).indexOf(M)>-1?L.classList.remove("beae-hidden"):L.classList.add("beae-hidden")})}function m(C){C.code.toUpperCase()==="ENTER"&&C.preventDefault()}function y(C,_,M){C.stopPropagation(),M.search.value="",k(_,M)}function S(C,_,M){(!_.contains(C.target)||!_.contains(C.relatedTarget))&&(B(_,M),M.button.setAttribute("aria-expanded",(M.button.getAttribute("aria-expanded")==="false").toString()))}function B(C,_){_.panel.classList.add("hidden-dropdown"),_.search&&(_.search.value="",k(C,_))}function w(C){const _=g(C);h&&C.addEventListener("focusout",M=>S(M,C,_)),_.button.addEventListener("click",()=>f(_)),C.querySelectorAll(".beae-country-name").forEach(M=>M.addEventListener("click",V=>u(V,_))),_.search&&(_.search.addEventListener("keyup",()=>k(C,_)),_.search.addEventListener("keydown",m)),_.resetButton&&(_.resetButton.addEventListener("click",M=>y(M,C,_)),_.resetButton.addEventListener("mousedown",M=>M.preventDefault()))}x.el.querySelectorAll(".beae-localization").forEach(w) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tt8ugopv: ', ex)
      };
    

      try {
        let argid = 'beae-dcvrt8qiblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-dcvrt8qi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-dcvrt8qi');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-dcvrt8qi: ', ex)
      };
    

      try {
        let argid = 'beae-b2wesd8kblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-b2wesd8k',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-b2wesd8k');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-b2wesd8k: ', ex)
      };
    }; if (window.BEAEBASE) {js_JMN5KDII()} else {window.BEAEPAGEJS.push(js_JMN5KDII)} })(); 